<template>
  <PortalPageShell
    :title="pageTitle"
    :subtitle="$t('portal.roleManager')"
  >
  <div class="portal-form-card edit-user">
    <div class="loader" v-if="loading"></div>
    <div class="card card-primary border-0 m-0">
      <div class="card-body">
        <div class="form-group">
          <label for="name">{{ $t("createRole.title")}}</label>
          <input type="text" name="name"
            class="form-control"
            v-model="roles.name"
            required
          />
        </div>
        <div id="demo" >
        <h5>{{ $t("createRole.assignPermission")}}</h5>
              <div class="d-flex justify-content-around">
                <div class="User">
                  <h5>User</h5>
                  <div v-for="(permission,idx) in getPermissions" :key="idx">
                    <div v-if="permission.name.includes('User')">
                      <input type="checkbox" :value="permission.id" id="permission.id" v-model="selectedPermission" @change="check($event)"> 
                      {{formatName(permission.name)}}
                    </div>
                  </div>
                </div>
                <div class="Gate">
                  <h5>Gate</h5>
                  <div v-for="(permission,idx) in getPermissions" :key="idx">
                    <div v-if="permission.name.includes('Gate')">
                      <input type="checkbox" :value="permission.id" id="permission.id" v-model="selectedPermission" @change="check($event)"> 
                      {{formatName(permission.name)}}
                    </div>
                  </div>
                </div>
                <div class="CheckinRow">
                  <h5>Check-in Row</h5>
                  <div v-for="(permission,idx) in getPermissions" :key="idx">
                    <div v-if="permission.name.includes('CheckinRow')">
                      <input type="checkbox" :value="permission.id" id="permission.id" v-model="selectedPermission" @change="check($event)"> 
                      {{formatName(permission.name)}}
                    </div>
                  </div>
                </div>
                <div class="Role">
                  <h5>Role</h5>
                  <div v-for="(permission,idx) in getPermissions" :key="idx">
                    <div v-if="permission.name.includes('Role')">
                      <input type="checkbox" :value="permission.id" id="permission.id" v-model="selectedPermission" @change="check($event)"> 
                      {{formatName(permission.name)}}
                    </div>
                  </div>
                </div>
                <div class="Claim">
                  <h5>Claim</h5>
                  <div v-for="(permission,idx) in getPermissions" :key="idx">
                    <div v-if="permission.name.includes('Claim')">
                      <input type="checkbox" :value="permission.id" id="permission.id" v-model="selectedPermission" @change="check($event)"> 
                      {{formatName(permission.name)}}
                    </div>
                  </div>
                </div>
                <div class="Status">
                  <h5>Status</h5>
                  <div v-for="(permission,idx) in getPermissions" :key="idx">
                    <div v-if="permission.name.includes('Status')">
                      <input type="checkbox" :value="permission.id" id="permission.id" v-model="selectedPermission" @change="check($event)"> 
                      {{formatName(permission.name)}}
                    </div>
                  </div>
                </div>
                <div class="Airline">
                  <h5>Airline</h5>
                  <div v-for="(permission,idx) in getPermissions" :key="idx">
                    <div v-if="permission.name.includes('Airline')">
                      <input type="checkbox" :value="permission.id" id="permission.id" v-model="selectedPermission" @change="check($event)"> 
                      {{formatName(permission.name)}}
                    </div>
                  </div>
                </div>
                <div class="Flight">
                  <h5>Flight</h5>
                  <div v-for="(permission,idx) in getPermissions" :key="idx">
                    <div v-if="permission.name.includes('Flight')">
                      <input type="checkbox" :value="permission.id" id="permission.id" v-model="selectedPermission" @change="check($event)"> 
                      {{formatName(permission.name)}}
                    </div>
                  </div>
                </div>
                <div class="Audit">
                  <h5>Audit</h5>
                  <div v-for="(permission,idx) in getPermissions" :key="idx">
                    <div v-if="permission.name.includes('Audit')">
                      <input type="checkbox" :value="permission.id" id="permission.id" v-model="selectedPermission" @change="check($event)"> 
                      {{formatName(permission.name)}}
                    </div>
                  </div>
                </div>
              </div>
        </div>
      </div>

      <div>
        <button v-if="this.$router.currentRoute.name == 'new-user-role'" class="btn btn-primary ml-4 mb-4" @click="createRole">{{ $t("createRole.btnRole")}}</button>
        <button v-if="this.$router.currentRoute.name == 'edit-user-role'" class="btn btn-primary ml-4 mb-4" @click="updateRole">{{ $t("createRole.editBtn")}}</button>
      </div>
    </div>
  </div>
  </PortalPageShell>
</template>

<script>
import PortalPageShell from '../layout/PortalPageShell.vue';
import axios from 'axios';
import { routeNames } from '../../js/routeNames';
export default {
  components: {
    PortalPageShell,
  },
  data() {
    return {
      getPermissions: '',
      roles: {
        name: '',
        permissions: ''
      },
      nameCheck: '',
      selectedPermission: [],
      loading: false,
    };
  },
  computed: {
    routeNames: () => { return routeNames; },
    pageTitle() {
      return this.$router.currentRoute.name === 'new-user-role'
        ? this.$t('createRole.title')
        : this.$t('createRole.title');
    },
  },
  mounted() {
    this.loading = true;
    if(this.$router.currentRoute.name == 'edit-user-role'){
      axios.get(this.$hostName + '/getAllPermissions')
      .then((response) => {
        this.getPermissions = response.data;
      });
      
      this.roles.name = this.$route.params.name;
      this.nameCheck = this.$route.params.name;
      axios.get(this.$hostName + '/getRolePermissions/'+ this.$route.params.roleid)
      .then((response) => {
        let data = Object.keys(response.data).map((key) => {
                    return response.data[key].id;
                  });
        this.selectedPermission = data;
      })
      .finally(() => {
        
        this.loading =  false;
      });
    }
    else{
      axios.get(this.$hostName + '/getAllPermissions')
      .then((response) => {
        this.getPermissions = response.data;
      })
      .finally(() => {
        this.loading =  false;
      });
    }
    
  },
  methods: {
    check: function() {
    },
    formatName(name){
      return name.split('-').join(' ');
    },
    updateRole(){
      if(this.roles.name==''){
        this.$alert('Enter Role Name');
      }
      else if(this.selectedPermission==''){
        this.$alert('Select atleast one permission');
      }
      else{
        this.loading = true;
        this.roles.permissions = this.selectedPermission;
        axios.put(this.$hostName + '/roles/' + this.$route.params.roleid,{
          name: this.roles.name,
          permissions: this.roles.permissions,
          nameCheck: this.nameCheck
        })
        .then(response => {
          if(response.status==202){
            this.loading = false;
            this.$alert('Role already Exists');
          }
          else{
            this.loading =  false;
            this.$router.push({name: routeNames.manageRole});
          }
        });
      }
    },
    createRole(){
      if(this.roles.name==''){
        this.$alert('Enter Role Name');
      }
      else if(this.selectedPermission==''){
        this.$alert('Select atleast one permission');
      }
      else{
        this.loading = true;
        this.roles.permissions = this.selectedPermission;
        axios.post(this.$hostName + '/roles',{
          name: this.roles.name,
          permissions: this.roles.permissions
        })
        .then(response => {
          if(response.status==202){
            this.loading = false;
            this.$alert('Role already Exists');
          }
          else{
            this.loading =  false;
            this.$router.push({name:routeNames.manageRole});
          }
        });
      }
      
    },
    goToRoute(route) {
      if(this.navOpen) this.toggleNav();
      if(route == this.$router.currentRoute.name) return;
      this.$router.push({ name: route });
    }

    
  }
};
</script>
<style scoped>
.loader{  /* Loader Div Class */
    position: absolute;
    top:0px;
    right:0px;
    width:100%;
    height:100%;
    background-color:#eceaea;
    background-image: url('../../assets/loading.gif');
    background-size: 50px;
    background-repeat:no-repeat;
    background-position:center;
    z-index:10000000;
    opacity: 0.4;
    filter: alpha(opacity=40);
}
</style>